import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {orders as ordersAction, tradeHistoryLoadedAll as tradeHistoryLoadedAllAction} from 'actions'
import useTradeHistory from './useTradeHistory'
import useOpenFutureStatus from './useOpenFutureStatus'

const LIMIT = 10
let curPage = 1

function useTradeHistoryDataProvider (isLogin, symbol, start, end, isFocus, symbolInfo) {
  const dispatch = useDispatch()
  const {data: loadedTradeHistories, hasMore} = useTradeHistory(symbolInfo)
  const ifOpenFuture = useOpenFutureStatus()
  const fetchData = useCallback(
    async () => {
      if (isLogin && ifOpenFuture) {
        const {tradeHistories} = await ApiSdk.futures.getTradeHistory({
          symbol,
          startTime: start,
          endTime: end,
          page: curPage,
        })
        if (tradeHistories) {
          if (Object.keys(tradeHistories).length < LIMIT) {
            dispatch(tradeHistoryLoadedAllAction())
          } else {
            dispatch(tradeHistoryLoadedAllAction(true))
          }
          dispatch(ordersAction({tradeHistories}))
        } else {
          dispatch(tradeHistoryLoadedAllAction())
        }
      }
    },
    [isLogin, ifOpenFuture, symbol, start, end, dispatch]
  )

  const loadMore = useCallback(() => {
    if (!hasMore) return Promise.resolve()
    curPage++
    return fetchData()
  }, [fetchData, hasMore])

  useEffect(() => {
    if (isFocus) {
      curPage = 1
      dispatch(ordersAction({tradeHistories: {}}))
      fetchData()
    }
  }, [fetchData, isFocus, dispatch])

  return {
    data: loadedTradeHistories,
    fetchData,
    loadMore,
    hasMore
  }
}

export default useTradeHistoryDataProvider
